var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDementia = function SvgDementia(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4.675 23.25v-6.265A9.365 9.365 0 0 1 11.05.75c7.14 0 8.68 5.878 11.225 12.48a.75.75 0 0 1-.7 1.02h-1.9v3a3 3 0 0 1-3 3h-1.5v3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    strokeDasharray: "2 3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.969 5.938c.915 1.007.42 3.133-.843 3.64-2.498 1.003-5.172 2.075-7.39 2.964-1.263.507-2.897-.765-2.932-2.126-.068-2.674 1.443-5.196 3.987-6.217s5.38-.241 7.178 1.739"
  })));
};
export default SvgDementia;